module.exports = __webpack_public_path__ + "img/FlagOutlined.1ecd6195.svg";